import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
    ExportExcelModalComponent
} from "../../components/modal/components/export-excel-modal/export-excel-modal.component";

import {RecordManager} from "../record/record.manager";
import {AsyncActionInput} from "../process/processes/async-action/async-action";

const V_TABLE = {
    'scrm-export-excel': ExportExcelModalComponent
};

@Injectable({
    providedIn: 'root',
})
export class PersistedModalService {

    constructor(
        protected modalService: NgbModal,
        protected recordManager: RecordManager,
    ) {
    }

    show(viewSelector: string, config: any, data: AsyncActionInput): void {
        const modal = this.modalService.open(V_TABLE[viewSelector], {size: 'xl', scrollable: true});
        if (modal) {
            modal.componentInstance.config = config;
            modal.componentInstance.asyncActionInput = data;
        }
    }

}
